export default "__VITE_ASSET__0zxwHxIn__"